import { useCallback, useEffect, useState } from "react";
import { Loader2, MonitorSmartphone, ShieldPlus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Panel } from "@/components/KpiCard";
import { appareil } from "@/components/ConnexionsPanel";
import { api, errMsg } from "@/lib/api";

const date = (v) => (v ? new Date(v).toLocaleString("fr-CA") : "—");

export const AppareilsPanel = () => {
  const [liste, setListe] = useState(null);
  const charger = useCallback(() => api.get("/appareils").then((r) => setListe(r.data)).catch((e) => toast.error(errMsg(e))), []);
  useEffect(() => { charger(); }, [charger]);
  const retirer = async (a) => {
    if (!window.confirm(`Retirer « ${appareil(a.nom)} » ? Un code par courriel sera redemandé à sa prochaine connexion.`)) { return; }
    try { await api.delete(`/appareils/${a.id}`); toast.success("Appareil retiré"); charger(); } catch (e) { toast.error(errMsg(e)); }
  };
  const memoriser = async () => {
    try { await api.post("/appareils/actuel"); toast.success("Cet appareil est maintenant de confiance"); charger(); } catch (e) { toast.error(errMsg(e)); }
  };
  if (!liste) return <Loader2 className="h-5 w-5 animate-spin text-emerald-700" />;
  return (
    <Panel title="Appareils de confiance" testId="appareils-panel"
      action={!liste.some((a) => a.actuel) && <Button size="sm" variant="outline" onClick={memoriser} data-testid="appareil-memoriser"><ShieldPlus className="h-3.5 w-3.5 mr-1" />Mémoriser cet appareil</Button>}>
      <p className="text-xs text-slate-500 mb-3 flex items-center gap-1"><MonitorSmartphone className="h-3.5 w-3.5" />Ces appareils se connectent sans code. Tout autre appareil doit saisir un code reçu par courriel.</p>
      <div className="divide-y divide-slate-100" data-testid="appareils-liste">
        {liste.map((a) => (
          <div key={a.id} className="flex flex-wrap items-center justify-between gap-3 py-2.5" data-testid={`appareil-${a.id}`}>
            <div className="min-w-0">
              <p className="text-sm font-medium text-slate-800" title={a.nom}>
                {appareil(a.nom) || "Appareil inconnu"}
                {a.actuel && <span className="ml-2 rounded-full bg-emerald-50 px-2 py-0.5 text-xs text-emerald-700" data-testid={`appareil-actuel-${a.id}`}>Cet appareil</span>}
              </p>
              <p className="text-xs text-slate-500">Ajouté le {date(a.created_at)} · Dernière connexion {date(a.dernier_usage)} · IP <span className="font-mono">{a.ip}</span></p>
            </div>
            <Button size="sm" variant="outline" className="h-8 text-xs" onClick={() => retirer(a)} data-testid={`appareil-retirer-${a.id}`}><Trash2 className="h-3.5 w-3.5 mr-1" />Retirer</Button>
          </div>
        ))}
        {!liste.length && <p className="py-3 text-sm text-slate-500" data-testid="appareils-vide">Aucun appareil mémorisé pour l'instant.</p>}
      </div>
    </Panel>
  );
};
